<template>
  <v-container class="step">
    <v-row justify="center" class="full-height">
      <v-col class="s6-container">
        <div xs="12" sm="6" md="5"  class="s6-left">
          <div class="image-container"
            data-aos="fade-right"
            data-aos-delay="0"
            data-aos-duration="2000"
            data-aos-mirror="true"
            data-aos-once="false"
          >
                <v-img
                  class="s6-img"
                  contain
                  :src="baseUrl + '/media/image/renb_pic7.png'">
                </v-img>
          </div>
          </div>
          <div xs="12" sm="6" md="7" class="s6-right">
                <div class="s6-txt"
                  data-aos="fade-left"
                  data-aos-delay="0"
                  data-aos-duration="2000"
                  data-aos-mirror="true"
                  data-aos-once="false"
                >
                  <p class="s6-txt-1">
                    {{$t("_s6_txt_1")}}
                  </p>
                  <p class="s6-txt-2">
                    {{$t("_s6_txt_2")}}
                  </p>
                </div>
            </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL
    }
  }
}
</script>

<style scoped>
.s6-container {
    width: 100%; /* Chiều rộng của div */
    height: 100%; /* Hoặc có thể là một giá trị cụ thể như 500px */
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
}
.s6-left {
  width: 40%;
  max-height: 80%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.s6-right {
  width: 60%;
  max-height: 80%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.s6-img {
  /* max-height: 80%; */
  object-fit: contain;
  position: relative;
}
.s6-txt {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  height: 500px;
  width: 500px;
  line-height: 2;
}
.s6-txt-1 {
  font-family: "ZenkakuBlack";
  font-weight: 500;
}
.s6-txt-2 {
  white-space: pre-line;
}
.image-container {
  width: 100%;
  height: 100%;
}
@media (max-width: 960px) {
  .s6-container {
      align-items: start;
  }
  .step {
    height: unset!important;
    scroll-snap-align:unset;
    margin-top: 20%;
  }
  .full-height {
    height: unset!important;
    width: 100%;
  }
  .s6-right {
    width: 50%;
    position: relative;
    display: block;
    position: relative;
    top: 0;
    padding: 0 20px;
  }
  .s6-left {
    width: 49%;
  }
  .s6-img {
    /* max-height: 500px; */
    width: 100%;
  }
  .s6-txt {
    height: 100%;
    width: 100%;
    line-height: 2;
    height: 500px;
  }
}
@media (max-width: 600px) {
  .s6-right {
    width: 100%;
  }
  .s6-left {
    width: 100%;
  }
  .s6-container {
    flex-direction: column;
    padding: unset!important;
  }
  .s6-right {
    padding: 0 10px;
  }
  .s6-txt-1 {
    font-weight: 500;
  }
}
</style>